import { GrowthSocialLogo } from "./GrowthSocialLogo";
import { Progress } from "./ui/progress";

interface LoadingFallbackProps {
  message?: string;
  progress?: number;
}

export const LoadingFallback = ({ message = "Loading...", progress }: LoadingFallbackProps) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-background to-muted">
      <div className="flex flex-col items-center gap-4 w-full max-w-md px-4">
        <GrowthSocialLogo height={48} animate />
        <p className="text-sm text-muted-foreground/80">The Social Media Platform for B2B SaaS</p>
        <p className="text-muted-foreground animate-pulse">{message}</p>
        {progress !== undefined && (
          <Progress value={progress} className="w-full h-2" />
        )}
      </div>
    </div>
  );
};
